/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModelModel, BrandModel } from "../../Utils/Models";
import { useEffect, useRef, useState } from "react";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { onChangeTextField } from "../../Utils/Utils";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { toast } from "react-toastify";

type ModelProps = {
  editModel: ModelModel | null;
  open: boolean;
  addOrUpdateModel: (model: ModelModel | null) => void;
  onClose: () => void;
};

export default function Model(props: ModelProps) {
  const { editModel, open, addOrUpdateModel, onClose } = props;
  const ref: any = useRef();
  const [model, setModel] = useState<ModelModel>(new ModelModel());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [brands, setBrands] = useState<Array<BrandModel>>([]);

  /**
   * Fetch brands on mount
   */
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const data = await getData(urlEnum.brands);
        setBrands(data.data.result);
      } catch (error) {
        toast.error(`${error}`);
      }
    };
    fetchBrands();
  }, []);

  /**
   *
   */
  useEffect(() => {
    if (editModel) {
      setModel(editModel);
    } else {
      setModel(new ModelModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editModel]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateModel(model)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.model}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextValidator
              size="small"
              id="name"
              name="name"
              label={Vocabulary.name}
              fullWidth
              variant="outlined"
              value={model.name}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                setModel(onChangeTextField(event, model))
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Autocomplete
              size="small"
              id="brand"
              freeSolo={false}
              disablePortal
              getOptionLabel={(option: any) => option.name || ""}
              isOptionEqualToValue={(option: any, value: any) =>
                option._id === value._id
              }
              options={brands}
              value={model.brand}
              onChange={(event: any, value: any) => {
                setModel({ ...model, brand: value });
              }}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="brand"
                  label={Vocabulary.brand}
                  variant="outlined"
                />
              )}
            />
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
